<template>
  <el-main>
    <el-container>
      <div v-html="privacy_policy"></div>
    </el-container>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      privacy_policy: null,
    };
  },
  mounted() {
    request({
      url: "general-information",
      method: "GET",
    }).then((response) => {
      this.privacy_policy = response.data.data.privacy_policy;
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue